import React, { useState, useEffect, useMemo } from 'react';
import './FrontDeskSMS.css';

// SMS Templates data
const TEMPLATES = [
  { cat: "Scheduling", t: "Reschedule — Offer New Time", msg: "Hi [Customer's Name], it's Gloss Nail Bar! Can we move your [Date] at [Time] with [Tech] to [New Time]? Your current slot is held until we hear back!", ph: ["Customer's Name", "Date", "Time", "Tech", "New Time"] },
  { cat: "Scheduling", t: "Reschedule — Move Later", msg: "Hi [Customer's Name], it's Gloss Nail Bar! Could we shift your [Date] at [Time] with [Tech] to [New Time]? No worries if not — your slot is still yours!", ph: ["Customer's Name", "Date", "Time", "Tech", "New Time"] },
  { cat: "Scheduling", t: "Reschedule — Move Earlier", msg: "Hi [Customer's Name], it's Gloss Nail Bar! Could we move your [Date] at [Time] with [Tech] up to [New Time]? Your original time is still held if not!", ph: ["Customer's Name", "Date", "Time", "Tech", "New Time"] },
  { cat: "Scheduling", t: "Weather — No-Penalty Reschedule", msg: "Hi [Customer's Name], it's Gloss Nail Bar! With today's weather, please prioritize your safety. If you'd like to reschedule, there's no penalty at all!", ph: ["Customer's Name"] },
  { cat: "Scheduling", t: "Confirm — Two Services, Different Times", msg: "Hi [Customer's Name], it's Gloss Nail Bar! You have two services on [Date] at different times. Would you like to start them together or keep them separate?", ph: ["Customer's Name", "Date"] },
  { cat: "Scheduling", t: "Confirm — Duplicate Bookings Found", msg: "Hi [Customer's Name], it's Gloss Nail Bar! We noticed bookings on [Date 1] at [Time 1] and [Date 2] at [Time 2]. Would you like to keep both or adjust?", ph: ["Customer's Name", "Date 1", "Time 1", "Date 2", "Time 2"] },
  { cat: "Scheduling", t: "Closure Notice — Closing Early", msg: "Hi [Customer's Name], it's Gloss Nail Bar! We're closing early at [Time] today due to [Reason] and will reopen [Date]. Can we help reschedule you?", ph: ["Customer's Name", "Time", "Reason", "Date"] },
  { cat: "Scheduling", t: "Closure Notice — Closed All Day", msg: "Hi [Customer's Name], it's Gloss Nail Bar! We're closed today for [Reason] and will reopen [Date]. We'd love to reschedule you — what works best?", ph: ["Customer's Name", "Reason", "Date"] },
  { cat: "Scheduling", t: "Late Guest — Grace Period", msg: "Hi [Customer's Name], it's Gloss Nail Bar! If you arrive by [Latest Time], we can fit your full service. After that we may need to adjust. Keep us posted!", ph: ["Customer's Name", "Latest Time"] },
  { cat: "Scheduling", t: "Late Guest — Service May Be Adjusted", msg: "Hi [Customer's Name], it's Gloss Nail Bar! Glad you made it. Your service may be adjusted slightly to stay on schedule. We'll still take great care of you!", ph: ["Customer's Name"] },
  { cat: "Scheduling", t: "Welcome — First Visit Details", msg: "Hi [Customer's Name], it's Gloss Nail Bar! We're excited for your visit on [Date] at [Time]. We're at 504 W Gray St Ste B, Montrose. Arrive a few mins early!", ph: ["Customer's Name", "Date", "Time"] },
  { cat: "Technician", t: "Tech Unavailable — Emergency", msg: "Hi [Customer's Name], it's Gloss Nail Bar! Unfortunately, [Tech] had an emergency today. We can pair you with another tech or reschedule — your preference!", ph: ["Customer's Name", "Tech"] },
  { cat: "Technician", t: "Tech Unavailable — Running Behind", msg: "Hi [Customer's Name], it's Gloss Nail Bar! [Tech] is running about [Time Delay] behind. Would [New Time] work for you? We appreciate your patience!", ph: ["Customer's Name", "Tech", "Time Delay", "New Time"] },
  { cat: "Technician", t: "Tech Unavailable — Leaving Early", msg: "Hi [Customer's Name], it's Gloss Nail Bar! [Tech] needs to leave early today. We can pair you with another tech or reschedule — whatever you prefer!", ph: ["Customer's Name", "Tech"] },
  { cat: "Technician", t: "Tech Unavailable — Starting Late", msg: "Hi [Customer's Name], it's Gloss Nail Bar! [Tech] is starting [Time Delay] late today. Would [New Time] work, or can we pair you with another tech?", ph: ["Customer's Name", "Tech", "Time Delay", "New Time"] },
  { cat: "Technician", t: "Tech Unavailable — On Leave", msg: "Hi [Customer's Name], it's Gloss Nail Bar! [Tech] is out until [Date]. We'd love to take care of you — can we schedule you with another tech?", ph: ["Customer's Name", "Tech", "Date"] },
  { cat: "Technician", t: "Tech Schedule — New Availability", msg: "Hi [Customer's Name], it's Gloss Nail Bar! [Tech]'s schedule is now [New Days]. We can reschedule you or pair you with another tech — let us know!", ph: ["Customer's Name", "Tech", "New Days"] },
  { cat: "Technician", t: "Tech Departure — Reassign Guest", msg: "Hi [Customer's Name], it's Gloss Nail Bar! [Tech] is no longer with our team. We have wonderful techs we'd love to pair you with — let us know!", ph: ["Customer's Name", "Tech"] },
  { cat: "Technician", t: "Tech Reassignment — Better Fit", msg: "Hi [Customer's Name], it's Gloss Nail Bar! For your [Date] at [Time], we'd like to pair you with a tech who may be an even better fit. Let us know!", ph: ["Customer's Name", "Date", "Time"], note: "If the guest asks why: \"[Tech] always wants to deliver the best experience and felt another tech might better meet your expectations.\"" },
  { cat: "Technician", t: "Deposit Required — No-Show History", msg: "Hi [Customer's Name], it's Gloss Nail Bar! A $50 deposit is now needed for future bookings (refundable with 24+ hrs notice). Call (281) 974-2828 to book!", ph: ["Customer's Name"] },
  { cat: "Technician", t: "Master Tech No-Show — Deposit Forfeited", msg: "Hi [Customer's Name], it's Gloss Nail Bar! Per our policy, your $50 deposit is forfeited unless approved documentation is provided. Reach out with questions!", ph: ["Customer's Name"] },
  { cat: "Technician", t: "Master Tech — Request Documentation", msg: "Hi [Customer's Name], it's Gloss Nail Bar! If you can share documentation for your missed appointment, we'd be glad to keep your deposit active. Thank you!", ph: ["Customer's Name"] },
  { cat: "Technician", t: "Master Tech — Documentation Approved", msg: "Hi [Customer's Name], it's Gloss Nail Bar! Your documentation has been approved. We can roll your deposit forward or issue a refund — your preference!", ph: ["Customer's Name"] },
  { cat: "Technician", t: "Master Tech — New Deposit Needed", msg: "Hi [Customer's Name], it's Gloss Nail Bar! A new deposit is needed by [Deadline Date] for your rescheduled Master Tech booking. Call (281) 974-2828 to confirm!", ph: ["Customer's Name", "Deadline Date"] },
  { cat: "Technician", t: "Master Tech — Deposit Deadline Today", msg: "Hi [Customer's Name], it's Gloss Nail Bar! A deposit is needed for your Master Tech appointment. Call by 6 PM today to confirm or the spot will be released.", ph: ["Customer's Name"] },
  { cat: "Booking", t: "Group Inquiry — Deposit Schedule", msg: "Hi! Groups of 4+ need a deposit (applied to your bill, refundable with 24+ hrs notice). 4/$100, 6/$150, 8/$200, 10+/$300+. Call (281) 974-2828 to book!", ph: [] },
  { cat: "Booking", t: "Group Deposit — Deadline Today", msg: "Hi [Customer's Name], it's Gloss Nail Bar! Please submit your group deposit by 6:30 PM today or we'll need to release the slot. Call (281) 974-2828!", ph: ["Customer's Name"] },
  { cat: "Booking", t: "Group No-Show — Deposit Forfeited", msg: "Hi [Customer's Name], it's Gloss Nail Bar! Your group deposit is forfeited per policy unless documentation is provided. Reach out — we'd love to rebook!", ph: ["Customer's Name"] },
  { cat: "Booking", t: "Waitlist — Added to List", msg: "Hi [Customer's Name], it's Gloss Nail Bar! We're fully booked for that time, but we'd love to add you to our waitlist. We'll reach out if a spot opens!", ph: ["Customer's Name"] },
  { cat: "Booking", t: "Waitlist — Spot Available", msg: "Hi [Customer's Name], it's Gloss Nail Bar! Great news — a spot just opened for your [Service] today at [Time]. Would you like it? Let us know!", ph: ["Customer's Name", "Service", "Time"] },
  { cat: "Booking", t: "Waitlist — Spot with Requested Tech", msg: "Hi [Customer's Name], it's Gloss Nail Bar! A spot just opened for your [Service] at [Time] with [Tech]. Would you like to grab it? Let us know!", ph: ["Customer's Name", "Service", "Time", "Tech"] },
  { cat: "Guest Relations", t: "Gift Card — 7-Day Hold Notice", msg: "Just so you know, online gift cards have a 7-day hold before redemption to verify the transaction and protect our guests. Reach out anytime with questions!", ph: [] },
  { cat: "Guest Relations", t: "Gift Card — Security Verification", msg: "Hi [Customer's Name], it's Gloss Nail Bar. We need to verify the gift card from your visit. Could you share the purchaser's name and phone? Thank you!", ph: ["Customer's Name"] },
  { cat: "Guest Relations", t: "Repair — Complimentary Fix (In Window)", msg: "Hi [Customer's Name], it's Gloss Nail Bar! Your [Service] is within our repair window — we'd love to fix it. Call (281) 974-2828. Come with nails as-is!", ph: ["Customer's Name", "Service"] },
  { cat: "Guest Relations", t: "Repair — Window Expired", msg: "Hi [Customer's Name], it's Gloss Nail Bar! Our repair window for [Service] is [Window] from your [Original Date] visit. We can rebook at regular pricing!", ph: ["Customer's Name", "Service", "Window", "Original Date"] },
  { cat: "Guest Relations", t: "Refund Request — Policy Redirect", msg: "Hi [Customer's Name], it's Gloss Nail Bar! Our policy is to correct concerns rather than refund. We'd love to make it right — call (281) 974-2828 to schedule!", ph: ["Customer's Name"] },
  { cat: "Guest Relations", t: "Escalation — Manager Will Follow Up", msg: "Hi [Customer's Name], it's Gloss Nail Bar! Thank you for your patience. We've shared your concern with our manager, and they will follow up with you shortly.", ph: ["Customer's Name"] },
  { cat: "Guest Relations", t: "Escalation — Guest Requests Manager", msg: "Hi [Customer's Name], it's Gloss Nail Bar! We understand. Our manager has been notified and will reach out to you directly. Thank you for your patience!", ph: ["Customer's Name"] },
  { cat: "Guest Relations", t: "Job Inquiry — Resume Redirect", msg: "Hi [Applicant's Name], thanks for your interest in Gloss! Please email your resume to hiring@glossnail.bar — if you're a match, our team will be in touch!", ph: ["Applicant's Name"] },
  { cat: "Guest Relations", t: "Inquiry — Pricing & Menu", msg: "Hi [Customer's Name], it's Gloss Nail Bar! Our full menu and pricing are at glossnail.bar. If you need a recommendation, we're happy to help — just let us know!", ph: ["Customer's Name"] },
  { cat: "Guest Relations", t: "Inquiry — Hours & Location", msg: "Hi! Gloss Nail Bar is located at 504 W Gray St Ste B, Houston TX 77019 (Montrose). Find our hours and book online at glossnail.bar!", ph: [] },
  { cat: "Guest Relations", t: "Inquiry — Parking & Directions", msg: "Hi [Customer's Name]! We're at 504 W Gray St Ste B, Montrose. Street parking on W Gray and side streets. Call (281) 974-2828 if you need help finding us!", ph: ["Customer's Name"] },
  { cat: "Guest Relations", t: "Inquiry — Custom Service Quote", msg: "Hi [Customer's Name], it's Gloss Nail Bar! Based on your request, that service would be approximately [Price]. We'd love to book you — call (281) 974-2828!", ph: ["Customer's Name", "Price"] },
  { cat: "Guest Relations", t: "Inquiry — Service Duration", msg: "Hi [Customer's Name], it's Gloss Nail Bar! Your [Service] typically takes about [Duration]. Please plan accordingly and reach out with any questions!", ph: ["Customer's Name", "Service", "Duration"] },
  { cat: "Guest Relations", t: "Service Discontinuation — Final Notice", msg: "Hi [Customer's Name], it's Gloss Nail Bar. Due to [Reason], we've made the difficult decision to discontinue services. We wish you all the best.", ph: ["Customer's Name", "Reason"], note: "For general discontinuation, use \"careful consideration\" as [Reason]. For behavioral, keep it factual: \"behavior toward our staff,\" \"repeated policy violations,\" etc. Do not elaborate or debate. If the guest responds, do not engage — route to management." },
  { cat: "Guest Relations", t: "Policy — Children in Salon", msg: "Hi [Customer's Name], it's Gloss Nail Bar! Kids are welcome by appointment for their own services. For safety, they can't be in the area during adult visits.", ph: ["Customer's Name"] },
  { cat: "Experience", t: "Recovery — Request Photos & Summary", msg: "Hi [Customer's Name], it's Gloss Nail Bar! We're sorry about your experience. Could you share a brief summary and a few photos so we can address it? Thank you!", ph: ["Customer's Name"] },
  { cat: "Experience", t: "Recovery — Request Photos", msg: "Hi [Customer's Name], it's Gloss Nail Bar! We're sorry about your experience. Could you send a few photos so we can look into it? We want to make it right!", ph: ["Customer's Name"] },
  { cat: "Experience", t: "Recovery — Request Summary", msg: "Hi [Customer's Name], it's Gloss Nail Bar! We're sorry your visit wasn't up to standard. Could you share a brief summary of what happened? Thank you!", ph: ["Customer's Name"] },
  { cat: "Experience", t: "Recovery — Offer Complimentary Redo", msg: "Hi [Customer's Name], it's Gloss Nail Bar! We'd love to offer a complimentary correction. Call (281) 974-2828 to schedule — ideally within the next few days!", ph: ["Customer's Name"] },
  { cat: "Experience", t: "Recovery — Redo Denied", msg: "Hi [Customer's Name], it's Gloss Nail Bar! After review, we've determined the service met our standards. We're sorry and hope to welcome you back soon.", ph: ["Customer's Name"], note: "Use only after management has reviewed photos/summary. Do not offer discounts or concessions — if management wants to offer a goodwill gesture, send a separate follow-up." },
  { cat: "Experience", t: "Recovery — Allergic Reaction Follow-Up", msg: "Hi [Customer's Name], it's Gloss Nail Bar! Sorry about a reaction after your visit. Could you send photos? If severe, please see a doctor. We'll follow up!", ph: ["Customer's Name"], note: "Route all allergic reaction reports to management immediately. Do not make any admissions of fault. Express concern, document, and follow up after management review." },
  { cat: "Experience", t: "Recovery — Negative Review Outreach", msg: "Hi [Customer's Name], it's Gloss Nail Bar! We're sorry your visit fell short. We'd love to make it right — call (281) 974-2828 or email help@glossnail.bar!", ph: ["Customer's Name"], note: "Never reference the specific platform (Google, Yelp) or quote the review. Keep it warm and solution-oriented. The goal is to move the conversation to a private channel." },
  { cat: "Policy", t: "Cannot Service — Nail Health Concern", msg: "Hi [Customer's Name], it's Gloss Nail Bar! Our tech noticed a [Condition] to address before we proceed. We recommend a dermatologist — welcome back once clear!", ph: ["Customer's Name", "Condition"], note: "Keep [Condition] general: \"nail concern,\" \"skin sensitivity in the service area,\" etc. State board regulations prohibit servicing clients with infections, fungus, or open wounds. Never diagnose — only recommend they see a professional." },
  { cat: "Policy", t: "Cannot Assess — Self-Removed Enhancements", msg: "Hi [Customer's Name], it's Gloss Nail Bar! Since enhancements were self-removed, we can't assess the work. We'd love to book a fresh set — call (281) 974-2828!", ph: ["Customer's Name"] },
  { cat: "Policy", t: "Early Arrival — Please Wait", msg: "Hi [Customer's Name], it's Gloss Nail Bar! Your appointment starts at [Time] and your tech is finishing up. Have a seat — we'll get you started right on time!", ph: ["Customer's Name", "Time"] },
  { cat: "Policy", t: "Accommodations — How Can We Help", msg: "Hi [Customer's Name], it's Gloss Nail Bar! We're happy to accommodate your needs. Please let us know what would help — call (281) 974-2828 with details!", ph: ["Customer's Name"] },
  { cat: "Policy", t: "Not Available — Off-Menu Request", msg: "Hi [Customer's Name], it's Gloss Nail Bar! We don't currently offer [Service], but you can view our full menu at glossnail.bar. We'd love to find a fit!", ph: ["Customer's Name", "Service"] },
  { cat: "Policy", t: "Redirect — Use Salon Number", msg: "Hi [Customer's Name], it's Gloss Nail Bar! For scheduling and inquiries, please contact us at (281) 974-2828. Our front desk team is happy to assist you!", ph: ["Customer's Name"] },
  { cat: "Operations", t: "Service Error — Complimentary Redo", msg: "Hi [Customer's Name], it's Gloss Nail Bar! We apologize for the service mix-up. We'd love to bring you back at no charge. Call (281) 974-2828 to reschedule!", ph: ["Customer's Name"] },
  { cat: "Operations", t: "Payment Failed — Call to Resolve", msg: "Hi [Customer's Name], it's Gloss Nail Bar! Your recent payment didn't process. Could you call (281) 974-2828 at your convenience to resolve? Thank you!", ph: ["Customer's Name"], note: "Do not specify the amount or detailed card info over text. Handle payment details over the phone only." },
  { cat: "Operations", t: "Lost & Found — Item at Front Desk", msg: "Hi [Customer's Name], it's Gloss Nail Bar! You may have left [Item] here. It's safe at the front desk — call (281) 974-2828 or stop by within [Days] days!", ph: ["Customer's Name", "Item", "Days"] },
  { cat: "Operations", t: "Follow-Up — Google Review Request", msg: "Hi [Customer's Name], it's Gloss Nail Bar! If you enjoyed your visit, a quick Google review would mean so much to us: [Review Link]. Thank you!", ph: ["Customer's Name", "Review Link"] },
  { cat: "Operations", t: "Missed Call — How Can We Help", msg: "Hi [Customer's Name], it's Gloss Nail Bar! We're sorry we missed your call. How can we help? You can also book online anytime at glossnail.bar!", ph: ["Customer's Name"] },
  { cat: "Operations", t: "Voicemail Received — Following Up", msg: "Hi [Customer's Name], it's Gloss Nail Bar! We received your voicemail and wanted to follow up. How can we assist you? Feel free to call or text us back!", ph: ["Customer's Name"] },
  { cat: "Operations", t: "Tip Adjustment — Call to Process", msg: "Hi [Customer's Name], it's Gloss Nail Bar! We'd be happy to adjust your tip. Please call us at (281) 974-2828 and we'll take care of it right away!", ph: ["Customer's Name"] },
  { cat: "Operations", t: "Receipt — Copy Requested", msg: "Hi [Customer's Name], it's Gloss Nail Bar! We'd be happy to send a copy of your receipt. Could you confirm the date of your visit and we'll get that to you?", ph: ["Customer's Name"] },
  { cat: "Operations", t: "After Hours — We'll Reply When Open", msg: "Hi [Customer's Name], thanks for reaching out to Gloss Nail Bar! We're closed but will reply when we open. Browse and book at glossnail.bar in the meantime!", ph: ["Customer's Name"] }
];

const CATEGORY_META = {
  "Scheduling": "Shift, confirm, closures, late arrivals",
  "Technician": "Emergency, schedule changes, deposits, no-shows",
  "Booking": "Group reservations, waitlists, openings",
  "Guest Relations": "Gift cards, policies, repairs, quotes, escalation",
  "Experience": "Service recovery, reactions, reviews",
  "Policy": "Health, accommodations, off-menu, boundaries",
  "Operations": "Payments, lost items, calls, receipts, after-hours"
};

const GROUPS = {
  "Scheduling": [["Reschedule", ["Reschedule", "Weather"]], ["Confirmations", ["Confirm"]], ["Closures", ["Closure"]], ["Arrivals & Situations", ["Late Guest", "Welcome"]]],
  "Technician": [["Availability", ["Tech Unavailable", "Tech Schedule"]], ["Reassignment", ["Tech Departure", "Tech Reassignment"]], ["Deposits & No-Shows", ["Deposit", "Master Tech"]]],
  "Booking": [["Groups", ["Group"]], ["Waitlist", ["Waitlist"]]],
  "Guest Relations": [["Gift Cards", ["Gift Card"]], ["Repairs & Refunds", ["Repair", "Refund"]], ["Escalation", ["Escalation"]], ["Inquiries", ["Inquiry", "Job Inquiry"]], ["Policies & Notices", ["Service Discontinuation", "Policy", "Children"]]],
  "Experience": [["Recovery Requests", ["Request"]], ["Recovery Outcomes", ["Offer", "Denied", "Allergic", "Negative"]]],
  "Policy": [["Service Restrictions", ["Cannot"]], ["Guest Situations", ["Early Arrival", "Accommodations"]], ["Boundaries", ["Not Available", "Redirect"]]],
  "Operations": [["Service & Payment", ["Service Error", "Payment Failed"]], ["Guest Follow-Up", ["Lost", "Follow-Up", "Missed", "Voicemail"]], ["Requests", ["Tip", "Receipt"]], ["After Hours", ["After Hours"]]]
};

function getGroup(cat, title) {
  const gs = GROUPS[cat];
  if (!gs) return "Other";
  for (const g of gs) {
    const [groupName, prefixes] = g;
    for (const prefix of prefixes) {
      if (title.includes(prefix)) return groupName;
    }
  }
  return "Other";
}

function FrontDeskSMS() {
  const [activeCat, setActiveCat] = useState(null);
  const [activeTemplate, setActiveTemplate] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');
  const [values, setValues] = useState({});
  const [collapsedGroups, setCollapsedGroups] = useState({});
  const [copied, setCopied] = useState(false);
  const [customMessage, setCustomMessage] = useState('');
  const [customCopied, setCustomCopied] = useState(false);

  const categories = useMemo(() => {
    const cats = [];
    const seen = new Set();
    for (const t of TEMPLATES) {
      if (!seen.has(t.cat)) {
        seen.add(t.cat);
        cats.push(t.cat);
      }
    }
    return cats;
  }, []);

  const byCategory = (cat) => TEMPLATES.filter(t => t.cat === cat);

  const searchResults = useMemo(() => {
    if (!searchQuery) return [];
    const q = searchQuery.toLowerCase();
    return TEMPLATES.filter(t => 
      t.t.toLowerCase().includes(q) || 
      t.msg.toLowerCase().includes(q) || 
      t.cat.toLowerCase().includes(q)
    );
  }, [searchQuery]);

  const handleCategoryClick = (cat) => {
    setActiveCat(cat);
    setActiveTemplate(null);
    setValues({});
    setCopied(false);
    setCustomMessage('');
    setCustomCopied(false);
  };

  const handleTemplateClick = (idx) => {
    setActiveTemplate(idx);
    setValues({});
    setCopied(false);
    setCustomCopied(false);
    // Initialize custom message with original
    const template = TEMPLATES[idx];
    setCustomMessage(template.msg);
  };

  const handleBackToWelcome = () => {
    setActiveCat(null);
    setActiveTemplate(null);
    setSearchQuery('');
    setValues({});
  };

  const handleValueChange = (key, value) => {
    setValues(prev => ({ ...prev, [key]: value }));
  };

  const toggleGroup = (groupKey) => {
    setCollapsedGroups(prev => ({
      ...prev,
      [groupKey]: !prev[groupKey]
    }));
  };

  const fillPlaceholders = (template, templateIdx) => {
    let result = template.msg;
    for (const ph of template.ph) {
      const key = `${templateIdx}-${ph}`;
      const val = values[key] || `[${ph}]`;
      result = result.split(`[${ph}]`).join(val);
    }
    return result;
  };

  const copyToClipboard = async (text, isCustom = false) => {
    try {
      await navigator.clipboard.writeText(text);
      if (isCustom) {
        setCustomCopied(true);
        setTimeout(() => setCustomCopied(false), 1800);
      } else {
        setCopied(true);
        setTimeout(() => setCopied(false), 1800);
      }
    } catch (err) {
      // Fallback
      const ta = document.createElement('textarea');
      ta.value = text;
      ta.style.position = 'fixed';
      ta.style.opacity = '0';
      document.body.appendChild(ta);
      ta.select();
      try {
        document.execCommand('copy');
        if (isCustom) {
          setCustomCopied(true);
          setTimeout(() => setCustomCopied(false), 1800);
        } else {
          setCopied(true);
          setTimeout(() => setCopied(false), 1800);
        }
      } catch (e) {}
      document.body.removeChild(ta);
    }
  };

  const currentTemplate = activeTemplate !== null ? TEMPLATES[activeTemplate] : null;
  const filledMessage = currentTemplate ? fillPlaceholders(currentTemplate, activeTemplate) : '';
  const charCount = filledMessage.length;
  const segments = charCount > 160 ? Math.ceil(charCount / 160) : 1;

  // Render sidebar navigation
  const renderSidebar = () => (
    <nav className="sms-sidebar">
      <div className="sms-sidebar-header">
        <div className="sms-eyebrow">Gloss Nail Bar</div>
        <div className="sms-title">SMS Templates</div>
      </div>
      <div className="sms-sidebar-search">
        <div className="sms-search-wrap">
          <svg className="sms-search-icon" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
            <circle cx="11" cy="11" r="8"/><path d="m21 21-4.3-4.3"/>
          </svg>
          <input 
            type="text" 
            placeholder="Search..." 
            value={searchQuery}
            onChange={(e) => {
              setSearchQuery(e.target.value);
              if (e.target.value) {
                setActiveCat(null);
                setActiveTemplate(null);
              }
            }}
          />
        </div>
      </div>
      <div className="sms-sidebar-nav">
        <div className="sms-nav-label">Categories</div>
        {categories.map(cat => {
          const count = byCategory(cat).length;
          const isActive = activeCat === cat && !searchQuery;
          return (
            <div 
              key={cat}
              className={`sms-nav-item ${isActive ? 'on' : ''}`}
              onClick={() => handleCategoryClick(cat)}
            >
              <div className="sms-nav-name">{cat}</div>
              <div className="sms-nav-count">{count}</div>
            </div>
          );
        })}
      </div>
      <div className="sms-sidebar-footer">
        <div className="sms-footer-text">glossnail.bar</div>
        <svg className="sms-footer-arch" width="70" height="35" viewBox="0 0 70 35" fill="none">
          <path d="M20 35 L20 15 Q20 0 32 0 Q44 0 44 15 L44 35" stroke="#d4a0a8" strokeWidth=".8"/>
          <path d="M30 35 L30 12 Q30 0 39 0 Q48 0 48 12 L48 35" stroke="#e0b8c4" strokeWidth=".6"/>
        </svg>
      </div>
    </nav>
  );

  // Render welcome view
  const renderWelcome = () => (
    <div className="sms-welcome">
      <svg className="sms-welcome-arch" style={{right: 24}} width="70" height="150" viewBox="0 0 70 150" fill="none" opacity="0.1">
        <path d="M0 150 L0 70 Q0 0 35 0 Q70 0 70 70 L70 150" stroke="#d4a0a8" strokeWidth="1"/>
      </svg>
      <svg className="sms-welcome-arch" style={{right: 60}} width="58" height="125" viewBox="0 0 58 125" fill="none" opacity="0.07">
        <path d="M0 125 L0 58 Q0 0 29 0 Q58 0 58 58 L58 125" stroke="#e0b8c4" strokeWidth=".8"/>
      </svg>
      
      <div className="sms-welcome-hero">
        <div className="sms-welcome-eyebrow">Gloss Nail Bar ✦ Staff Reference</div>
        <div className="sms-welcome-title">SMS Templates</div>
        <div className="sms-welcome-desc">
          Pre-written messages for scheduling, guest relations, service recovery, and more. 
          Find the right template, fill in the guest's details, and copy — ready to send in seconds.
        </div>
      </div>

      <div className="sms-welcome-section">How It Works</div>
      <div className="sms-welcome-steps">
        <div className="sms-welcome-step">
          <div className="sms-step-num">01</div>
          <div className="sms-step-title">Pick a Category</div>
          <div className="sms-step-desc">Select from the sidebar based on the situation — scheduling, tech issues, guest concerns, etc.</div>
        </div>
        <div className="sms-welcome-step">
          <div className="sms-step-num">02</div>
          <div className="sms-step-title">Choose a Template</div>
          <div className="sms-step-desc">Browse the template list and click one to open the detail view.</div>
        </div>
        <div className="sms-welcome-step">
          <div className="sms-step-num">03</div>
          <div className="sms-step-title">Fill In & Copy</div>
          <div className="sms-step-desc">Replace the pink placeholders with the guest's actual info. Hit copy — it's on your clipboard.</div>
        </div>
      </div>

      <div className="sms-welcome-section">{TEMPLATES.length} Templates Across {categories.length} Categories</div>
      <div className="sms-welcome-cats">
        {categories.map(cat => {
          const count = byCategory(cat).length;
          return (
            <div key={cat} className="sms-welcome-cat" onClick={() => handleCategoryClick(cat)}>
              <div className="sms-cat-info">
                <div className="sms-cat-name">{cat}</div>
                <div className="sms-cat-desc">{CATEGORY_META[cat]}</div>
              </div>
              <div className="sms-cat-count">{count}</div>
              <svg className="sms-cat-arrow" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
                <polyline points="9 6 15 12 9 18"/>
              </svg>
            </div>
          );
        })}
      </div>
    </div>
  );

  // Render search results
  const renderSearchResults = () => (
    <div className="sms-search-wrap-results">
      <div className="sms-search-label">{searchResults.length} result{searchResults.length !== 1 ? 's' : ''}</div>
      {searchResults.length > 0 ? (
        searchResults.map((result, idx) => {
          const originalIdx = TEMPLATES.indexOf(result);
          return (
            <div 
              key={idx}
              className="sms-search-result"
              onClick={() => {
                setActiveCat(result.cat);
                setActiveTemplate(originalIdx);
                setSearchQuery('');
              }}
            >
              <div className="sms-result-cat">{result.cat}</div>
              <div className="sms-result-name">{result.t}</div>
            </div>
          );
        })
      ) : (
        <div className="sms-search-empty">No templates match your search.</div>
      )}
    </div>
  );

  // Render template list
  const renderTemplateList = () => {
    const items = byCategory(activeCat);
    let lastGroup = "";
    let num = 0;

    return (
      <div className="sms-tlist">
        <div className="sms-tlist-header">
          <div className="sms-tlist-title">{activeCat}</div>
          <div className="sms-tlist-count">{items.length} templates</div>
        </div>
        <div className="sms-tlist-items">
          {items.map((item, idx) => {
            const originalIdx = TEMPLATES.indexOf(item);
            const group = getGroup(activeCat, item.t);
            const groupKey = `${activeCat}:${group}`;
            const isCollapsed = collapsedGroups[groupKey];
            const isActive = activeTemplate === originalIdx;
            num++;

            const elements = [];
            
            if (group !== lastGroup) {
              lastGroup = group;
              elements.push(
                <div 
                  key={`group-${group}`}
                  className={`sms-subgroup ${isCollapsed ? 'collapsed' : ''}`}
                  onClick={() => toggleGroup(groupKey)}
                >
                  <div className="sms-sg-label">{group}</div>
                  <div className="sms-sg-line"></div>
                  <svg className="sms-sg-arrow" width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
                    <polyline points="6 9 12 15 18 9"/>
                  </svg>
                </div>
              );
            }

            elements.push(
              <div 
                key={`template-${originalIdx}`}
                className={`sms-template-row ${isActive ? 'on' : ''} ${isCollapsed ? 'sg-hidden' : ''}`}
                onClick={() => handleTemplateClick(originalIdx)}
              >
                <div className="sms-row-num">{num}</div>
                <div className="sms-row-name">{item.t}</div>
              </div>
            );

            return elements;
          })}
        </div>
      </div>
    );
  };

  // Render template detail
  const renderTemplateDetail = () => {
    if (!currentTemplate) {
      return (
        <div className="sms-detail">
          <div className="sms-detail-empty">
            <svg className="sms-empty-icon" width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1" strokeLinecap="round">
              <rect x="3" y="3" width="18" height="18" rx="2"/>
              <line x1="9" y1="9" x2="15" y2="9"/>
              <line x1="9" y1="13" x2="13" y2="13"/>
            </svg>
            <div className="sms-empty-title">Select a Template</div>
            <div className="sms-empty-sub">Choose from the list to preview, customize, and copy your message.</div>
          </div>
        </div>
      );
    }

    const highlightPlaceholders = (text) => {
      return text.replace(/\[([^\]]+)\]/g, '<span class="sms-ph">[$1]</span>');
    };

    return (
      <div className="sms-detail">
        <div className="sms-detail-inner">
          <div className="sms-ed-title">{currentTemplate.t}</div>
          <div className="sms-ed-cat">{currentTemplate.cat}</div>
          
          {currentTemplate.note && (
            <div className="sms-note">
              <div className="sms-note-header">
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/>
                  <line x1="12" y1="9" x2="12" y2="13"/>
                  <line x1="12" y1="17" x2="12.01" y2="17"/>
                </svg>
                Read Before Sending
              </div>
              <div className="sms-note-body">{currentTemplate.note}</div>
            </div>
          )}

          <div className="sms-preview" dangerouslySetInnerHTML={{__html: highlightPlaceholders(currentTemplate.msg)}} />

          {currentTemplate.ph.length > 0 && (
            <>
              <div className="sms-form-header">Fill in Details</div>
              <div className="sms-form-grid">
                {currentTemplate.ph.map((ph, idx) => {
                  const key = `${activeTemplate}-${ph}`;
                  return (
                    <div key={idx} className="sms-field">
                      <div className="sms-field-label">{ph}</div>
                      <input 
                        type="text"
                        placeholder={ph}
                        value={values[key] || ''}
                        onChange={(e) => handleValueChange(key, e.target.value)}
                      />
                    </div>
                  );
                })}
              </div>
            </>
          )}

          {currentTemplate.ph.length === 0 && (
            <div className="sms-no-fields">No placeholders — ready to copy as-is.</div>
          )}

          <div className="sms-ready-header"><span>Ready to Send</span></div>
          <div className="sms-result">{filledMessage}</div>
          <div className="sms-actions">
            <button 
              className={`sms-copy-btn ${copied ? 'ok' : ''}`}
              onClick={() => copyToClipboard(filledMessage)}
            >
              {copied ? (
                <>
                  <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
                    <polyline points="20 6 9 17 4 12"/>
                  </svg>
                  Copied
                </>
              ) : (
                <>
                  <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="9" y="9" width="13" height="13" rx="2"/>
                    <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/>
                  </svg>
                  Copy Message
                </>
              )}
            </button>
            <div className="sms-char-count">
              {charCount} chars
              {charCount > 160 && (
                <span className="sms-segments"> · {segments} segments</span>
              )}
            </div>
          </div>

          <div className="sms-custom">
            <div className="sms-custom-header">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{color: '#a89888'}}>
                <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/>
                <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/>
              </svg>
              <div className="sms-custom-title">Need to Adjust?</div>
            </div>
            <div className="sms-custom-desc">
              Edit the message below if you need to add details like a specific time, date, or service that isn't covered by the placeholders above.
            </div>
            <textarea 
              className="sms-custom-area"
              value={customMessage}
              onChange={(e) => setCustomMessage(e.target.value)}
            />
            <div className="sms-custom-footer">
              <button 
                className={`sms-custom-copy ${customCopied ? 'ok' : ''}`}
                onClick={() => copyToClipboard(customMessage, true)}
              >
                {customCopied ? (
                  <>
                    <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
                      <polyline points="20 6 9 17 4 12"/>
                    </svg>
                    Copied
                  </>
                ) : (
                  <>
                    <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <rect x="9" y="9" width="13" height="13" rx="2"/>
                      <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/>
                    </svg>
                    Copy Custom
                  </>
                )}
              </button>
              <div className="sms-custom-cc">
                {customMessage.length} chars
                {customMessage.length > 160 && ` · ${Math.ceil(customMessage.length / 160)} segments`}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="sms-container">
      {renderSidebar()}
      <div className="sms-main">
        {searchQuery ? renderSearchResults() : 
         activeCat ? (
           <>
             {renderTemplateList()}
             {renderTemplateDetail()}
           </>
         ) : renderWelcome()}
      </div>
    </div>
  );
}

export default FrontDeskSMS;
